import { Grid2} from '@mui/material';
import React from 'react';
import { useGradingHistory } from './GradingHistoryContext';
import { Embryo, fetchEmbryoResult } from './EmbryoGradingAi.helper';
import EmbryoListItem from './EmbryoListItem';
import { useAlert } from '../../components/alertProvider';
import { useTranslation } from 'react-i18next';


const EmbryoListForGrading: React.FC = () => {

  const { addAlert } = useAlert();
  const { t: tAiGrading } = useTranslation('aiGrading_config');

  const { selectedEmbryosGrading , setSelectedEmbryosGrading , setSelectedEmbryoResult , setSelectedEmbryoForGrading } = useGradingHistory();
    
  

  
  const getEmbryoResult = (data: Embryo) => {
    fetchEmbryoResult(data, setSelectedEmbryoResult, addAlert , tAiGrading);
  };

 
 
  const handleSelect = (embryo: Embryo) => {
    const updated = selectedEmbryosGrading.map((p: Embryo) =>
      p.id === embryo.id
        ? { ...p, selected: true }
        : { ...p, selected: false }
    );

    setSelectedEmbryosGrading(updated);  // List
    setSelectedEmbryoForGrading(embryo); // selected Embryo

    getEmbryoResult(embryo);
  };




  return (
    <>     
      <Grid2  display="flex" gap={1}  flexDirection="column" size={12} height={'100%'} >
        <Grid2   size={12}  height={'calc(100vh - 355px)'} overflow={'auto'} pr={0.5}>
      
          {selectedEmbryosGrading.map((embryo : Embryo) => (
            <EmbryoListItem
              key={embryo.id}
              embryo={embryo}
              onClick={() => handleSelect(embryo)}
            />
          ))}

        </Grid2> 
      </Grid2>

    </>
  );
};
  
export default EmbryoListForGrading;